import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingFallback = ({ linear = false, height, sx }) => (
  <Box
    sx={{
      display: "flex",
      // width: "100%",
      justifyContent: "center",
      alignItems: "center",
      background: "#ffffff",
      // height: height,
      ...sx,
    }}
  >
    {linear ? (
      <LinearProgress style={{ width: "100%" }} />
    ) : (
      <CircularProgress size={height} />
    )}
  </Box>
);

export default LoadingFallback;
